"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as v } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as a } from "../../theme-variant-context.js";
import { vars as r } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: h, size: c = 24 } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = a(), o = h !== null && h !== void 0 ? h : t ? r.colors.inverse : r.colors.neutralHigh, { skinName: l } = n();
    return l.match(/^o2-new/i) ? /* @__PURE__ */ v("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ v("path", {
            fill: o,
            d: "M18.364 2.5h-5.82c-2.006 0-3.635 1.703-3.635 3.799v.38H5.636C3.629 6.678 2 8.38 2 10.476v3.8c0 1.833 1.252 3.37 2.91 3.726v2.738a.76.76 0 0 0 .447.7.7.7 0 0 0 .796-.165L9.21 18.08h2.244c2.007 0 3.636-1.702 3.636-3.799v-.063l2.761 2.885c.14.146.326.223.512.223q.14 0 .28-.058a.76.76 0 0 0 .446-.7v-2.739c1.658-.355 2.91-1.887 2.91-3.726v-3.8c0-2.1-1.63-3.803-3.636-3.803m-4.73 11.781c0 1.255-.978 2.282-2.183 2.282H8.904a.7.7 0 0 0-.512.224l-2.03 2.12v-1.585c0-.419-.326-.76-.726-.76-1.201 0-2.183-1.02-2.183-2.28v-3.8c0-1.255.977-2.281 2.183-2.281h3.273v1.902c0 2.096 1.63 3.799 3.636 3.799h1.09zm4.73-1.897c-.4 0-.726.34-.726.76v1.585l-2.03-2.121a.72.72 0 0 0-.512-.224h-2.547c-1.2 0-2.183-1.021-2.183-2.281v-3.8c0-1.254.978-2.28 2.183-2.28h5.82c1.2 0 2.183 1.021 2.183 2.28v3.8h-.005c0 1.255-.977 2.281-2.183 2.281"
        })
    })) : /* @__PURE__ */ v("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ v("path", {
            fill: o,
            d: "M18.364 2.5h-5.82c-2.006 0-3.635 1.703-3.635 3.799v.38H5.636C3.629 6.678 2 8.38 2 10.476v3.8c0 1.833 1.252 3.37 2.91 3.726v2.738a.76.76 0 0 0 .447.7.7.7 0 0 0 .796-.165L9.21 18.08h2.244c2.007 0 3.636-1.702 3.636-3.799v-.063l2.761 2.885c.14.146.326.223.512.223q.14 0 .28-.058a.76.76 0 0 0 .446-.7v-2.739c1.658-.355 2.91-1.887 2.91-3.726v-3.8c0-2.1-1.63-3.803-3.636-3.803m-4.73 11.781c0 1.255-.978 2.282-2.183 2.282H8.904a.7.7 0 0 0-.512.224l-2.03 2.12v-1.585c0-.419-.326-.76-.726-.76-1.201 0-2.183-1.02-2.183-2.28v-3.8c0-1.255.977-2.281 2.183-2.281h3.273v1.902c0 2.096 1.63 3.799 3.636 3.799h1.09zm4.73-1.897c-.4 0-.726.34-.726.76v1.585l-2.03-2.121a.72.72 0 0 0-.512-.224h-2.547c-1.2 0-2.183-1.021-2.183-2.281v-3.8c0-1.254.978-2.28 2.183-2.28h5.82c1.2 0 2.183 1.021 2.183 2.28v3.8h-.005c0 1.255-.977 2.281-2.183 2.281"
        })
    }));
}, u = i;
export { u as default };
